import { getDiscoveryUserRoute } from '../utils/apiRoutes';
import { axiosBuzzOne } from '../../../axios';
import { moduleName } from '../moduleInfo';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const getUserDiscoveryTableAsync = createAsyncThunk(
  `${moduleName}/getUserDiscoveryTableAsync`,
  async (payload) => {
    const { params } = payload;
    const response = await axiosBuzzOne({
      method: 'GET',
      url: getDiscoveryUserRoute(),
      params: { ...params },
    });
    const data = response.data;
    return data;
  }
);

export const getUserIdentityList = createAsyncThunk(
  `${moduleName}/identityList`,
  async (payload) => {
    const response = await axiosBuzzOne({
      method: 'GET',
      url: '/auth/identity/users',
    });
    const data = response.data;
    return data;
  }
);

export const changeUserIdentityPassword = createAsyncThunk(
  `${moduleName}/changeUserIdentityPassword`,
  async (payload) => {
    const response = await axiosBuzzOne({
      method: 'PUT',
      url: '/auth/identity/bcc/changepassword',
      data: payload,
    });
    const data = response.data;
    return data;
  }
);

const usersSlice = createSlice({
  name: `${moduleName}/ManagementAppApproval`,
  initialState: {
    loading: false,
    discoveryUserTable: null,
    userIdentityList: {
      loading: false,
      data: null,
    },
  },
  reducers: {},
  extraReducers: {
    [getUserDiscoveryTableAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [getUserDiscoveryTableAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.discoveryUserTable = action.payload.data;
    },
    [getUserDiscoveryTableAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    [getUserIdentityList.pending]: (state, action) => {
      state.userIdentityList.loading = true;
    },
    [getUserIdentityList.fulfilled]: (state, action) => {
      state.userIdentityList.loading = false;
      state.userIdentityList.data = action.payload.data;
    },
    [getUserIdentityList.rejected]: (state, action) => {
      state.userIdentityList.loading = false;
    },
  },
});

export default usersSlice.reducer;
